import { Text as TextPdf } from '@react-pdf/renderer'

const Text3 = (props) => {
  const {
    children,
    fontSize = '7px',
    textAlign = 'center',
    border,
    borderContent,
    minWidth,
    maxWidth,
    padding = '2px 3px',
    color = 'rgba(30,95,160,1)',
    bold,
    style,
  } = props

  const borderStyle = {
    borderTop: border?.top || borderContent ? '1px solid rgba(30,95,160,1)' : '',
    borderRight: border?.right || borderContent ? '1px solid rgba(30,95,160,1)' : '',
    borderBottom: border?.bottom || borderContent ? '1px solid rgba(30,95,160,1)' : '',
    borderLeft: border?.left || borderContent ? '1px solid rgba(30,95,160,1)' : '',
  }

  return (
    <TextPdf
      style={{
        ...borderStyle,
        color: color,
        minWidth: minWidth,
        maxWidth: maxWidth,
        fontSize: fontSize,
        textAlign: textAlign,
        padding: padding,
        fontFamily: bold ? 'Helvetica-Bold' : 'Helvetica',
        ...style,
      }}
    >
      {children !== 'null' ? children : '-'}
    </TextPdf>
  )
}

export default Text3
